// extracted by mini-css-extract-plugin
export default {"grid":"AddPerson_grid__5ZHn6","item":"AddPerson_item__pbivx","cancel_button":"AddPerson_cancel_button__OOUXI"};